import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const points = [
  "Responsive field services with fast mobilization",
  "Accurate, professional documentation and reporting",
  "Flexible scheduling built around your project timeline",
  "Safety-focused crews on every job site",
];

export default function About() {
  return (
    <section id="about" className="py-24 lg:py-32 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="lg:col-span-6"
          >
            <img src="/assets/aegis-logo-shield.webp" alt="Aegis Subsurface LLC" className="h-24 w-auto mb-8" data-testid="about-logo" />
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A00] mb-4 font-mono-tech" data-testid="about-overline">
              About Us • 02
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-[#0F172A]" data-testid="about-heading">
              Dependable. Safety-Focused. Built for the Field.
            </h2>
            <p className="mt-6 text-base text-slate-600 leading-relaxed" data-testid="about-body">
              Aegis Subsurface LLC is a Houston-area coring and boring contractor providing responsive field services,
              accurate documentation, and flexible scheduling throughout Greater Houston and surrounding communities.
              From single pavement cores to multi-boring geotechnical programs, our experienced technicians show up
              ready, work safely, and deliver clean, well-documented results your engineers can rely on.
            </p>
            <ul className="mt-8 space-y-4" data-testid="about-points">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#FF5A00] mt-0.5 shrink-0" />
                  <span className="text-base font-medium text-[#0F172A]">{p}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="lg:col-span-6 relative"
          >
            <div className="absolute -top-4 -left-4 w-full h-full border-2 border-[#FF5A00]" aria-hidden="true" />
            <img
              src="/assets/job7.webp"
              alt="Aegis Subsurface technician operating a core drill on asphalt"
              className="relative w-full h-[420px] lg:h-[520px] object-cover rounded-sm"
              data-testid="about-image"
            />
            <div className="absolute -bottom-6 -right-2 sm:right-6 bg-[#0F172A] text-white px-6 py-5 rounded-sm shadow-xl" data-testid="about-badge">
              <p className="font-heading text-2xl font-black uppercase text-[#FF5A00]">Greater Houston</p>
              <p className="text-sm text-slate-300 mt-1">And all surrounding areas</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
